// src/modules/app-views/omnichannel/pages/Init/actions/floatButton.js
// *******************************************************************************
// OMNICHANNEL FLOAT BUTTON ACTIONS
// *******************************************************************************
// Float button actions for conversation operations.
// - Escalate: create CRM opportunity or support ticket
// - Transfer: transfer conversation to another agent
// - Close: archive/close the conversation
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { RiseOutlined, SwapOutlined, UserAddOutlined } from '@ant-design/icons';
import { PiChatSlashBold } from 'react-icons/pi';
import { HiOutlineArchiveBoxArrowDown, HiOutlineArchiveBoxXMark } from 'react-icons/hi2';

// *******************************************************************************
// FLOAT BUTTON ACTIONS
// *******************************************************************************

/**
 * Build float button actions array for omnichannel conversation
 * @param {Object} context - Context with data and handlers
 * @param {Object} context.handlers - Action handlers
 * @param {boolean} context.isInQueue - Whether conversation is unassigned (in queue)
 * @returns {Array} Array of float button action configurations
 */
const omnichannelFloatButton = (context = {}) => {
  const { handlers = {}, isInQueue, isArchived } = context;

  const actions = [];

  // Archived conversations: only show unarchive action
  if (isArchived) {
    actions.push({
      key: 'archive',
      icon: <HiOutlineArchiveBoxXMark style={{ fontSize: 16 }} />,
      tooltipText: 'unarchive_conversation',
      onClick: handlers.onArchive,
    });
    return actions;
  }

  // Show "Assume" button only for queue conversations (no assignedTo)
  if (isInQueue && handlers.onAssume) {
    actions.push({
      key: 'assume',
      icon: <UserAddOutlined />,
      tooltipText: 'assign_conversation',
      onClick: handlers.onAssume,
    });
  }

  actions.push(
    {
      key: 'escalate',
      icon: <RiseOutlined />,
      tooltipText: 'escalate_service',
      onClick: handlers.onEscalate,
    },
    {
      key: 'transfer',
      icon: <SwapOutlined />,
      tooltipText: 'transfer_service',
      onClick: handlers.onTransfer,
    },
    {
      key: 'archive',
      icon: <HiOutlineArchiveBoxArrowDown style={{ fontSize: 16 }} />,
      tooltipText: 'archive_conversation',
      onClick: handlers.onArchive,
    },
    {
      key: 'close',
      icon: <PiChatSlashBold style={{ fontSize: 16 }} />,
      tooltipText: 'close_service',
      type: 'default',
      onClick: handlers.onClose,
    }
  );

  return actions;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default omnichannelFloatButton;
